import { BoostsConditionModeEnum, ConditionMode, ConditionType } from '../types'

export abstract class DistributionCondition {
  abstract type: ConditionType

  abstract validate(): boolean
}

export abstract class ValuesCondition extends DistributionCondition {
  mode: ConditionMode = ConditionMode.Include
  values: Array<number> = []

  validate(): boolean {
    if (Array.isArray(this.values)) {
      return this.values.length > 0
    } else {
      return false
    }
  }
}

export abstract class ValueCondition extends DistributionCondition {
  /**
   * @value: если передать null, то рассылку получат пользователи, которые еще ни разу не проявляли активности (кроме /start ничего не делали)
   * @value: если передать строку (дату), то рассылку получат пользователи, у которых активность раньше, чем переданная дата
   */
  value: string | null = null
  mode: ConditionMode = ConditionMode.Less

  validate(): boolean {
    return true
  }
}

export class SentCondition extends ValueCondition {
  type: ConditionType = ConditionType.Sent
}

export class ActivityCondition extends ValueCondition {
  type: ConditionType = ConditionType.Activity
}

export class UtmCondition extends ValuesCondition {
  type: ConditionType = ConditionType.Utm
}

export class LabelsCondition extends ValuesCondition {
  type: ConditionType = ConditionType.Labels
}

export class UsersCondition extends ValuesCondition {
  type: ConditionType = ConditionType.Users
}

export class BoostsCondition extends DistributionCondition {
  type: ConditionType = ConditionType.Boosts

  target_id: number | null = null
  count = 0
  mode: BoostsConditionModeEnum = BoostsConditionModeEnum.Equals

  validate(): boolean {
    return this.target_id !== null
  }
}

export type PossibleConditions = SentCondition
  | ActivityCondition
  | LabelsCondition
  | UsersCondition
  | UtmCondition
  | BoostsCondition
